import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiApostrofos';
const args = {};

export class PetastiApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
